import React, { useState } from "react";
import "./SapAbap.css";
import DownloadForm from "../DownloadForm/DownloadForm";

const SapHCMWorkforce = () => {
  const [showForm, setShowForm] = useState(false);

  const handleDownloadClick = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  return (
    <div className="sapfincon-wrapper">
      {/* Animated Background Circles */}
      <div className="background-animation">
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
      </div>

      {/* Header Section */}
      <div
        className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
        style={{ marginBottom: "90px" }}
      >
        <div className="container text-center py-5" style={{ marginTop: "-80px" }}>
          <h1 className="text-white display-1">Human Resource Management</h1>
          <div className="d-inline-flex text-white mb-5">
            <p className="m-0 text-uppercase">
              <a className="text-white" href="">Home</a>
            </p>
            <i className="fa fa-angle-double-right pt-1 px-3"></i>
            <p className="m-0 text-uppercase">SAP</p>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="sapfincon-flexbox">
        <div className="sapfincon-left">
          <div className="sapfincon-wrapper zoom-effect">
            <img
              src="/assets/img/sapfince.jpg"
              alt="SAP Banner"
              className="sapfincon-main-image"
            />
          </div>
        </div>
        <div className="sapfincon-right">
          <h2 className="sapfincon-title">Empower the Future of Workforce Management with SAP HCM</h2>
          <p className="sapfincon-description">
            SAP HCM is the go-to solution for managing an organization’s most valuable asset — its people. From hiring and onboarding to payroll, training, and performance management, SAP HCM enables businesses to handle the complete employee lifecycle efficiently.
          </p>
          <ul className="sapfincon-list">
            {[
              "Core HR Competency – Widely adopted by global organizations",
              "End-to-End HR Automation – Recruitment, payroll, appraisals, and exits",
              "Improved Compliance – Adheres to labor laws and company policies",
              "Data-Driven Decision Making – Real-time strategic HR analytics",
              "Integration with SAP Modules – Works with FICO, MM, etc.",
              "Versatile Careers – HRIS, SAP consulting, payroll admin",
            ].map((text, idx) => (
              <li className="sapfincon-list-item" key={idx}>
                <span className="sapfincon-icon">
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998
                       26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997
                       26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206
                       0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"/>
                  </svg>
                </span>
                <span className="sapfincon-text">{text}</span>
              </li>
            ))}
          </ul>
          <p className="sapfincon-careers">SAP HCM Consultant, HRIS Analyst, Payroll Administrator</p>
        </div>
      </div>

      {/* Course Upgrade Section */}
      <div className="sapfincon-content-section">
        <div className="container">
          <div className="upgrade-section">
            <h2 className="section-title">
              <strong>Upgrade your HR tech skills with BDM Technology’s Expert-Led SAP HCM Course!</strong>
            </h2>
            <p className="section-description">
              SAP HCM empowers organizations to efficiently manage every aspect of the employee lifecycle—from recruitment to retirement.
            </p>
          </div>

          {/* Why Study */}
          <div className="why-study-section">
            <h3 className="subsection-title"><strong>Why Study SAP Human Capital Management (HCM)?</strong></h3>
            <p className="subsection-description">
              SAP HCM helps HR departments automate and optimize human resource planning, talent management, and personnel administration. It's essential for a high-growth career in HR operations and ERP consulting.
            </p>
          </div>

          {/* Benefits */}
          <div className="benefits-section">
            <h3 className="subsection-title"><strong>Benefits of Learning SAP HCM</strong></h3>
            <ul className="benefits-list">
              <li><strong>Core HR Competency</strong> – Essential for enterprise HR processes.</li>
              <li><strong>HR Automation</strong> – Reduces manual work and errors.</li>
              <li><strong>Compliance Ready</strong> – Aligns with labor regulations.</li>
              <li><strong>HR Analytics</strong> – Helps in workforce strategy planning.</li>
              <li><strong>Cross-Module Connectivity</strong> – Integrates with FICO, MM, etc.</li>
              <li><strong>Job Versatility</strong> – From consulting to tech-driven HR roles.</li>
            </ul>
          </div>

          {/* Future Scope */}
          <div className="future-scope-section">
            <h3 className="subsection-title"><strong>Future Scope of SAP HCM</strong></h3>
            <ul className="scope-list">
              <li><strong>Digital HR Transformation</strong> – Shift toward AI-driven HR tools.</li>
              <li><strong>Cloud Migration</strong> – SAP SuccessFactors adoption rising.</li>
              <li><strong>Global Workforce Support</strong> – Multinational enterprise demand.</li>
              <li><strong>Strategic HR Planning</strong> – Data-driven decision making.</li>
              <li><strong>Freelancing & Consulting</strong> – High-paying project roles.</li>
            </ul>
          </div>

          {/* Key Features */}
          <div className="key-features-section">
            <h3 className="subsection-title">
              <strong>Key Features of BDM Technology</strong>
            </h3>
            <div className="features-grid">
              <div className="feature-item"><h4>100% Job-Oriented Training</h4><p>Curriculum tailored to industry needs.</p></div>
              <div className="feature-item"><h4>Industry Expert Faculties</h4><p>Learn from HR tech professionals.</p></div>
              <div className="feature-item"><h4>Flexible Demo Class Available</h4><p>Try before you enroll.</p></div>
              <div className="feature-item"><h4>Completed 400+ Batches</h4><p>Proven and successful program.</p></div>
              <div className="feature-item"><h4>Certification Guidance</h4><p>Get certified with our support.</p></div>
              <div className="feature-item"><h4>Live Practical Sessions</h4><p>Real-time projects and labs.</p></div>
              <div className="feature-item"><h4>Peaceful Environment</h4><p>Focus-driven and calm atmosphere.</p></div>
            </div>
          </div>

          {/* Who Should Enroll */}
          <div className="who-attend-section">
            <h3 className="subsection-title"><strong>Who Should Enroll</strong></h3>
            <ul className="attend-list">
              <li>HR Professionals looking to upgrade with ERP-based skills</li>
              <li>Graduates in human resources, business, or management</li>
              <li>Individuals aspiring to become SAP HCM Consultants or HRIS Analysts</li>
              <li>IT professionals aiming to transition into HR tech roles</li>
            </ul>
          </div>

          {/* Hiring Companies */}
          <div className="hiring-companies-section">
            <h3 className="subsection-title"><strong>Hiring Companies</strong></h3>
            <div className="companies-grid">
              {[
                "/assets/img/Cognizant.png",
                "/assets/img/tcs.jpg",
                "/assets/img/infoysis.jpg",
                "/assets/img/ibm.png",
                "/assets/img/hcl.png",
                "/assets/img/Accenture.png",
                "/assets/img/capgemini.png",
                "/assets/img/Deloitte.png",
                "/assets/img/nttdata.png",
                "/assets/img/wipro.png",
                "/assets/img/KaarTech.png",
                "/assets/img/lt.png",
                "/assets/img/Siemens.png",
                "/assets/img/techmahindra.png",
              ].map((logo, index) => (
                <div className="company-card" key={index}>
                  <img src={logo} alt="company" className="company-logo" />
                </div>
              ))}
            </div>
          </div>

          {/* Salary Overview */}
          <div className="salary-overview-section">
            <h3 className="subsection-title"><strong>Salary Overview</strong></h3>
            <div className="salary-grid">
              <div className="salary-item"><h4>Entry-Level (0–2 Years)</h4><p className="salary-amount">₹4.5 – ₹7.5 LPA</p></div>
              <div className="salary-item"><h4>Mid-Level (2–5 Years)</h4><p className="salary-amount">₹7.5 – ₹13 LPA</p></div>
              <div className="salary-item"><h4>Senior-Level (5+ Years)</h4><p className="salary-amount">₹13 – ₹20+ LPA</p></div>
              <div className="salary-item"><h4>SAP HCM Architects & HR Tech Leads</h4><p className="salary-amount">₹22 – ₹30+ LPA</p></div>
            </div>
          </div>

          {/* PDF Download */}
          <div className="download-section">
            <h3 className="download-heading">
              Want to know more? <br />
              <span>Please download the course PDF.</span>
            </h3>
            <button className="download-button" onClick={handleDownloadClick}>
              📄 Download Course PDF
            </button>
          </div>

          {showForm && (
            <DownloadForm
              onClose={handleCloseForm}
              courseName="SAP HCM"
              pdfUrl="/uploads/pdfs/05.pdf" // replace with actual
            />
          )}
        </div>
      </div>

    
    </div>
  );
};

export default SapHCMWorkforce;